import { Link } from "react-router-dom";

import LogoWhite from "components/Image/Logo/White";
import { WEB_URLS } from "settings";

export default function Footer() {
  return (
    <footer className="brand-hero">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          <div className="col-span-4">
            <Link to="/" className="hidden lg:block">
              <LogoWhite />
            </Link>

            <p className="mt-10 text-center text-base text-white sm:mt-6 lg:text-left">
              Abound Mortgages is a trading name of Ahauz Finance Limited
            </p>

            <p className="mt-10 text-center text-base text-white lg:text-left">
              Ahauz Finance Limited, trading as Abound Mortgages, is authorised
              and regulated by the Financial Conduct Authority
              <br />
              Firm Reference Number 846554
            </p>

            <p className="mt-6 text-center text-base text-white lg:text-left">
              Copyright © {new Date().getFullYear()} Fintern Limited. All
              rights reserved.
            </p>

            <div className="mt-8 text-center text-white lg:mt-16 lg:text-left">
              <p className="text-sm">
                Ahauz Finance Limited is registered in England and Wales
                No.11835452
              </p>
              <p className="mt-1 text-sm">
                Registered office: 1st Floor Commodity Quay, London, England,
                E1W 1AZ
              </p>
            </div>
          </div>

          <div className="order-first col-span-1 flex flex-col justify-between text-center lg:order-1 lg:text-right">
            <Link to="/" className="m-auto mb-10 block lg:mb-0 lg:hidden">
              <LogoWhite />
            </Link>

            <div>
              <h3 className="text-center text-base font-semibold tracking-wide text-white lg:text-right">
                Useful links
              </h3>
              <nav>
                <ul className="mt-2 space-y-1 lg:mt-3">
                  <li>
                    <a href={WEB_URLS.CONTACT} target="_blank" rel="noreferrer">
                      <span className="text-white underline-offset-4 hover:text-brand-lime hover:underline">
                        Contact
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={WEB_URLS.POLICIES.TERMS}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="text-white underline-offset-4 hover:text-brand-lime hover:underline">
                        Terms &amp; Conditions
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={WEB_URLS.POLICIES.PRIVACY}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="text-white underline-offset-4 hover:text-brand-lime hover:underline">
                        Privacy Notice
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={WEB_URLS.POLICIES.COOKIES}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="text-white underline-offset-4 hover:text-brand-lime hover:underline">
                        Cookie Policy
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={WEB_URLS.POLICIES.COMPLAINTS}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="text-white underline-offset-4 hover:text-brand-lime hover:underline">
                        Complaints
                      </span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
